export default __webpack_public_path__ + "f0a141fbe44d63fbbc26f7e927e25cef.png";